// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-messageLink":"jobSearchDetail-messageLink"};